// =============================================================================
// STREETSTICKER.COM — EGGSHELL CONFIGURATOR (US Edition)
// Namespaced under window.SSConfigurator to support multiple sections on page.
// Depends on: pricing.js (must be loaded before this file)
// =============================================================================

(function () {
  'use strict';

  window.SSConfigurator = window.SSConfigurator || {};

  window.SSConfigurator.boot = function (opts) {
    const { sectionId } = opts;
    const id = (suffix) => `${suffix}-${sectionId}`;
    const el = (suffix) => document.getElementById(id(suffix));

    // ----- STATE (default: square 2×2 in × 1000 — small size, high qty = strong per-sticker value) -----
    const STATE = {
      shape: 'square',
      sizeId: 'sq-2',
      sizeW: 2,
      sizeH: 2,
      isCustom: false,
      qty: 1000,
      artworkMode: 'upload',
      uploadedFile: null,
      emailLater: false
    };

    // ----- DOM refs -----
    const els = {
      sizeGrid:       el('SSSizeGrid'),
      sizeHint:       el('SSSizeHint'),
      qtyGrid:        el('SSQtyGrid'),
      customW:        el('SSCustomW'),
      customH:        el('SSCustomH'),
      customApply:    el('SSCustomApply'),
      customFields:   el('SSCustomFields'),
      customHField:   el('SSCustomHField'),

      perUnit:        el('SSPerUnit'),
      total:          el('SSTotal'),
      ctaPrice:       el('SSCtaPrice'),
      savingsBadge:   el('SSSavings'),
      savingsPct:     el('SSSavingsPct'),
      savingsAbs:     el('SSSavingsAbs'),
      breakdown:      el('SSBreakdown'),
      minNote:        el('SSMinNote'),

      propShape:      el('SSPropShape'),
      propSize:       el('SSPropSize'),
      propArea:       el('SSPropArea'),
      propQty:        el('SSPropQty'),
      propPerUnit:    el('SSPropPerUnit'),
      propArtwork:    el('SSPropArtwork'),
      propPriceCents: el('SSPropPriceCents'),
      propConfigJson: el('SSPropConfigJson'),
      cartQty:        el('SSCartQuantity'),

      uploadInput:    el('SSUploadInput'),
      uploadLabel:    el('SSUploadLabel'),
      uploadFile:     el('SSUploadFile'),
      uploadFileName: el('SSUploadFileName'),
      uploadFileClear:el('SSUploadFileClear'),
      panelUpload:    el('SSPanelUpload'),
      panelEmail:     el('SSPanelEmail'),
      emailLater:     el('SSEmailLater'),

      pricetableGrid: el('SSPricetableGrid'),
      pricetableShape:el('SSPricetableShape'),

      stickyCta:       el('SSStickyCta'),
      stickyBreakdown: el('SSStickyBreakdown'),
      stickyPrice:     el('SSStickyPrice'),
      stickyPer:       el('SSStickyPer'),
      mainCta:         el('SSAddToCart'),

      galleryVideo:        el('SSGalleryVideo'),
      galleryVideoToggle:  el('SSGalleryVideoToggle'),
      galleryShapeImgs:    el('SSShapeImgs'),

      form:           document.getElementById(`SSConfigForm-${sectionId}`)
    };

    // ----- GALLERY VIDEO TOGGLE -----
    if (els.galleryVideo && els.galleryVideoToggle && els.galleryShapeImgs) {
      els.galleryVideoToggle.addEventListener('click', () => {
        const showVideo = els.galleryVideo.hasAttribute('hidden');
        if (showVideo) {
          els.galleryVideo.hidden = false;
          els.galleryShapeImgs.style.visibility = 'hidden';
          els.galleryVideoToggle.setAttribute('aria-pressed', 'true');
          // Attempt to play; ignore promise rejection (autoplay policy)
          const v = els.galleryVideo.querySelector('video');
          if (v && typeof v.play === 'function') v.play().catch(() => {});
        } else {
          els.galleryVideo.hidden = true;
          els.galleryShapeImgs.style.visibility = '';
          els.galleryVideoToggle.setAttribute('aria-pressed', 'false');
          const v = els.galleryVideo.querySelector('video');
          if (v && typeof v.pause === 'function') v.pause();
        }
      });
    }

    // ----- STICKY CTA visibility — show when the main CTA scrolls off-screen -----
    // Move sticky-cta directly to <body> so no transformed/overflowed parent
    // can clip or restrict its fixed positioning.
    if (els.stickyCta && els.stickyCta.parentNode !== document.body) {
      document.body.appendChild(els.stickyCta);
    }
    if (els.stickyCta && els.mainCta && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Hide sticky when the main CTA is in view, show when it's out of view.
          els.stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
          els.stickyCta.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, {
        threshold: 0.05,
        rootMargin: '0px 0px -60px 0px' // trigger slightly before fully off-screen
      });
      io.observe(els.mainCta);
    }

    // ----- SHAPES -----
    const section = document.getElementById(`ProductConfigurator-${sectionId}`);
    section.querySelectorAll('.ss-shape').forEach(btn => {
      btn.addEventListener('click', () => selectShape(btn.dataset.shape));
    });

    function selectShape(shape) {
      STATE.shape = shape;
      section.querySelectorAll('.ss-shape').forEach(btn => {
        btn.setAttribute('aria-checked', btn.dataset.shape === shape ? 'true' : 'false');
      });
      // Swap shape-specific gallery image
      section.querySelectorAll('[data-shape-img]').forEach(imgDiv => {
        imgDiv.hidden = imgDiv.dataset.shapeImg !== shape;
      });
      if (!STATE.isCustom) {
        const first = PRICING.SHAPES[shape].sizes[0];
        STATE.sizeId = first.id; STATE.sizeW = first.w; STATE.sizeH = first.h;
      }
      if (shape === 'round' && STATE.isCustom) STATE.sizeH = STATE.sizeW;
      els.customFields.classList.toggle('is-round', shape === 'round');
      const lbl = els.customFields.querySelector('.ss-custom-size__field-label');
      if (lbl) lbl.textContent = shape === 'round' ? 'Diameter' : 'Width';
      renderSizes(); renderAll();
    }

    // ----- SIZES -----
    function renderSizes() {
      const shape = PRICING.SHAPES[STATE.shape];
      els.sizeGrid.innerHTML = '';
      shape.sizes.forEach(size => {
        const area = calcArea(STATE.shape, size.w, size.h);
        const checked = !STATE.isCustom && STATE.sizeId === size.id;
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-size';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', checked ? 'true' : 'false');
        btn.innerHTML = `<span class="ss-size__label">${size.label}</span><span class="ss-size__area">${area.toFixed(1)} in²</span>`;
        btn.addEventListener('click', () => {
          STATE.isCustom = false; STATE.sizeId = size.id;
          STATE.sizeW = size.w; STATE.sizeH = size.h;
          renderSizes(); renderAll();
        });
        els.sizeGrid.appendChild(btn);
      });
      if (STATE.isCustom) {
        const lbl = STATE.shape === 'round' ? `Ø ${STATE.sizeW} in` : `${STATE.sizeW} × ${STATE.sizeH} in`;
        const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-size ss-size--custom';
        btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', 'radio');
        btn.innerHTML = `<span class="ss-size__label">${lbl}</span><span class="ss-size__area">${area.toFixed(1)} in² · custom</span>`;
        els.sizeGrid.appendChild(btn);
      }
      if (els.sizeHint) els.sizeHint.textContent = STATE.isCustom ? 'Custom size' : 'Standard sizes';
    }

    // ----- CUSTOM SIZE -----
    els.customApply.addEventListener('click', applyCustom);
    [els.customW, els.customH].forEach(inp => {
      inp.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); applyCustom(); } });
      inp.addEventListener('input', () => inp.classList.remove('is-invalid'));
    });

    function applyCustom() {
      const min = PRICING.CUSTOM_MIN_IN, max = PRICING.CUSTOM_MAX_IN;
      let w = parseFloat(els.customW.value);
      let h = STATE.shape === 'round' ? w : parseFloat(els.customH.value);
      let valid = true;
      if (!Number.isFinite(w) || w < min || w > max) { els.customW.classList.add('is-invalid'); valid = false; }
      if (STATE.shape !== 'round' && (!Number.isFinite(h) || h < min || h > max)) {
        els.customH.classList.add('is-invalid'); valid = false;
      }
      if (!valid) return;
      STATE.isCustom = true; STATE.sizeId = 'custom';
      STATE.sizeW = Math.round(w * 10) / 10; STATE.sizeH = Math.round(h * 10) / 10;
      renderSizes(); renderAll();
      const det = els.customApply.closest('details');
      if (det) det.open = false;
    }

    // ----- QTY -----
    function renderQty() {
      els.qtyGrid.innerHTML = '';
      const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
      const shapeMult = (PRICING.SHAPE_MULTIPLIER && PRICING.SHAPE_MULTIPLIER[STATE.shape]) || 1.0;
      const setup = PRICING.SETUP_PER_STICKER || 0;
      const ref = Math.max(PRICING.MIN_UNIT_PRICE, (setup + PRICING.BASE_PER_IN2 * area) * shapeMult);
      PRICING.QUANTITY_TIERS.forEach(tier => {
        const p = priceFor(area, tier.qty, STATE.shape);
        const checked = STATE.qty === tier.qty;
        const isBest = tier.qty === 1000;
        const pct = Math.round(tier.discount * 100);
        const showStrike = tier.discount > 0 && ref > p.discountedPerUnit;
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-qty';
        btn.setAttribute('role', 'radio'); btn.setAttribute('aria-checked', checked ? 'true' : 'false');
        btn.innerHTML = `
          <span class="ss-qty__discount ${tier.discount === 0 ? 'ss-qty__discount--zero' : ''}">−${pct}%</span>
          <span class="ss-qty__count">${tier.qty.toLocaleString('en-US')}<span class="ss-qty__count-suffix">pcs</span></span>
          <span class="ss-qty__per">${showStrike ? `<span class="ss-qty__per-strike">${fmtUSDcents(ref)}</span>` : ''}${fmtUSDcents(p.discountedPerUnit)}/sticker</span>
          ${isBest ? '<span class="ss-qty__best">★ BEST SELLER</span>' : ''}
        `;
        btn.addEventListener('click', () => { STATE.qty = tier.qty; renderQty(); renderAll(); });
        els.qtyGrid.appendChild(btn);
      });
    }

    // ----- ARTWORK -----
    section.querySelectorAll('.ss-artwork-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const mode = tab.dataset.tab;
        STATE.artworkMode = mode;
        section.querySelectorAll('.ss-artwork-tab').forEach(t => {
          const a = t.dataset.tab === mode;
          t.classList.toggle('ss-artwork-tab--active', a);
          t.setAttribute('aria-selected', a ? 'true' : 'false');
        });
        els.panelUpload.hidden = mode !== 'upload';
        els.panelEmail.hidden = mode !== 'email';
      });
    });

    els.uploadInput.addEventListener('change', e => {
      const file = e.target.files[0]; if (!file) return;
      if (file.size > 25 * 1024 * 1024) {
        alert('File is too large (max. 25 MB).');
        els.uploadInput.value = ''; return;
      }
      STATE.uploadedFile = file;
      els.uploadFileName.textContent = `${file.name} · ${(file.size/1024/1024).toFixed(2)} MB`;
      els.uploadFile.hidden = false;
    });
    els.uploadFileClear.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      STATE.uploadedFile = null; els.uploadInput.value = ''; els.uploadFile.hidden = true;
    });
    ['dragenter','dragover'].forEach(ev => els.uploadLabel.addEventListener(ev, e => {
      e.preventDefault(); els.uploadLabel.classList.add('is-drag');
    }));
    ['dragleave','drop'].forEach(ev => els.uploadLabel.addEventListener(ev, e => {
      e.preventDefault(); els.uploadLabel.classList.remove('is-drag');
    }));
    els.uploadLabel.addEventListener('drop', e => {
      e.preventDefault();
      const f = e.dataTransfer.files[0];
      if (f) { els.uploadInput.files = e.dataTransfer.files; els.uploadInput.dispatchEvent(new Event('change')); }
    });
    els.emailLater.addEventListener('change', e => { STATE.emailLater = e.target.checked; });

    // ----- PRICE -----
    function renderPrice() {
      const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
      const p = priceFor(area, STATE.qty, STATE.shape);
      const s = calcSavings(area, STATE.qty, STATE.shape);
      const sizeStr = STATE.shape === 'round' ? `Ø ${STATE.sizeW} in` : `${STATE.sizeW} × ${STATE.sizeH} in`;
      const shapeLabel = PRICING.SHAPES[STATE.shape].label;

      els.perUnit.textContent  = fmtUSDcents(p.discountedPerUnit);
      els.total.textContent    = fmtUSD(p.total);
      els.ctaPrice.textContent = fmtUSD(p.total);
      els.breakdown.textContent = `${STATE.qty.toLocaleString('en-US')} × ${shapeLabel} ${sizeStr} · ${area.toFixed(1)} in² · ${fmtUSDcents(p.discountedPerUnit)}/sticker · free US shipping included`;

      // Update sticky-bottom-bar values
      if (els.stickyPrice)     els.stickyPrice.textContent     = fmtUSD(p.total);
      if (els.stickyPer)       els.stickyPer.textContent       = `${fmtUSDcents(p.discountedPerUnit)}/sticker`;
      if (els.stickyBreakdown) els.stickyBreakdown.textContent = `${STATE.qty.toLocaleString('en-US')} × ${shapeLabel} ${sizeStr}`;

      // Minimum order notice
      if (els.minNote) els.minNote.hidden = !(p.minimumApplied || p.tieredStepApplied);

      if (s.savedAbsolute > 0.5 && STATE.qty > PRICING.QUANTITY_TIERS[0].qty) {
        els.savingsBadge.classList.remove('is-zero');
        els.savingsPct.textContent = `−${Math.round(s.savedPercent)}%`;
        els.savingsAbs.textContent = `You save ${fmtUSD(s.savedAbsolute)}`;
      } else {
        els.savingsBadge.classList.add('is-zero');
        els.savingsPct.textContent = '−0%';
        els.savingsAbs.textContent = 'Order more to save more';
      }

      // price-flash animation
      els.total.classList.remove('ss-price-flash');
      void els.total.offsetWidth;
      els.total.classList.add('ss-price-flash');

      // Update hidden form fields for Shopify cart submission.
      // Quantity = total_cents (cents-as-quantity pricing pattern; variant must be $0.01)
      const totalCents = Math.round(p.total * 100);
      if (els.cartQty)        els.cartQty.value        = totalCents;
      if (els.propShape)      els.propShape.value      = shapeLabel;
      if (els.propSize)       els.propSize.value       = sizeStr;
      if (els.propArea)       els.propArea.value       = `${area.toFixed(1)} in²`;
      if (els.propQty)        els.propQty.value        = STATE.qty.toString();
      if (els.propPerUnit)    els.propPerUnit.value    = fmtUSDcents(p.discountedPerUnit);
      if (els.propPriceCents) els.propPriceCents.value = totalCents.toString();
      if (els.propConfigJson) els.propConfigJson.value = JSON.stringify({
        shape: STATE.shape, sizeW: STATE.sizeW, sizeH: STATE.sizeH,
        qty: STATE.qty, totalUSD: p.total
      });
    }

    // ----- PRICE TABLE -----
    function renderPriceTable() {
      const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
      const sizeStr = STATE.shape === 'round' ? `Ø ${STATE.sizeW} in` : `${STATE.sizeW} × ${STATE.sizeH} in`;
      if (els.pricetableShape) els.pricetableShape.textContent = `${sizeStr} ${PRICING.SHAPES[STATE.shape].label}`;
      if (!els.pricetableGrid) return;
      els.pricetableGrid.innerHTML = '';
      PRICING.QUANTITY_TIERS.forEach(tier => {
        const p = priceFor(area, tier.qty, STATE.shape);
        const active = tier.qty === STATE.qty;
        const pct = Math.round(tier.discount * 100);
        const cell = document.createElement('div');
        cell.className = 'ss-pricetable__cell' + (active ? ' ss-pricetable__cell--active' : '');
        cell.innerHTML = `${tier.discount > 0 ? `<span class="ss-pricetable__cell-discount">−${pct}%</span>` : ''}<span class="ss-pricetable__cell-qty">${tier.qty.toLocaleString('en-US')}</span><span class="ss-pricetable__cell-per">${fmtUSDcents(p.discountedPerUnit)}/sticker</span><span class="ss-pricetable__cell-total">${fmtUSD(p.total)}</span>`;
        cell.addEventListener('click', () => { STATE.qty = tier.qty; renderQty(); renderAll(); });
        els.pricetableGrid.appendChild(cell);
      });
    }

    // ----- FORM SUBMIT: artwork property -----
    if (els.form) {
      els.form.addEventListener('submit', () => {
        const artworkVal = STATE.artworkMode === 'upload'
          ? (STATE.uploadedFile ? STATE.uploadedFile.name : 'File to follow')
          : 'Via email — hello@streetsticker.com';
        if (els.propArtwork) els.propArtwork.value = artworkVal;
      });
    }

    function renderAll() { renderQty(); renderPrice(); renderPriceTable(); }

    // ----- INIT -----
    renderSizes(); renderAll();
  };

})();
